(function(){
  const tooltips = document.querySelectorAll('.tooltip')

  if (tooltips) {
    tooltips.forEach(tooltip => {
      const text = tooltip.querySelector('.tooltip-text')

      if (text) {
        tooltip.addEventListener('mouseenter', e => {
          setTimeout(function(){
            text.classList.add('active')
          }, 200)
        })

        tooltip.addEventListener('mouseleave', e => {
          text.classList.remove('active')

          // Make sure we remove this active class, so remove it again if we have to
          setTimeout(function(){
            text.classList.remove('active')
          }, 200)
        })
      } else {
        console.error('The tooltip does not have a child with the .tooltip-text class.')
      }

    });
  }
})();
